import type { FormSectionProps } from './FormSection'
import FormSection from './FormSection'
import NewFormSection from './NewFormSection'

export type { FormSectionProps }
export { NewFormSection }
export default FormSection
